import { render, staticRenderFns } from "./AddHospitals.vue?vue&type=template&id=e918b784&scoped=true"
import script from "./AddHospitals.vue?vue&type=script&lang=js"
export * from "./AddHospitals.vue?vue&type=script&lang=js"
import style0 from "./AddHospitals.vue?vue&type=style&index=0&id=e918b784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e918b784",
  null
  
)

export default component.exports